import emptyAppointment from "~/assets/images/dashboard/empty-appointment.svg";

type EmptyAppointmentProps = {
  description : string;
};

const EmptyAppointment = ({ description }: EmptyAppointmentProps) => {
   return (
    <div className="flex min-h-screen overflow-hidden">
      <div className="bg-white p-8 h-2/4 lg:h-3/4 border-[#0404041A] border-[1px] overflow-hidden rounded-lg shadow-md text-center flex flex-col justify-center items-center">
        {/* Icon Section */}
        <div className="flex justify-center mb-4">
          <div className="">
            <img src={emptyAppointment} alt='empty appointment image' sizes="25" />
          </div>
        </div>
        {/* Text Section */}
        <h2 className="lg:text-[20px] text-[16px] leading-[150%] font-medium mb-2">Nothing yet</h2>
        <p className="text-[#202020CC] text-base font-normal mb-6 lg:w-1/2 md:w-4/5 leading-[140%]">
          {description}
        </p>
      </div>
    </div>
  );
};

export default EmptyAppointment;
